<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 1 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="0.5"
      y1="18"
      x2="0.499999"
      y2="2.18557e-08"
      stroke="#EBEBED"
    />
  </svg>
</template>

<script>
export default {
  name: 'VerticalLine',
  props: {
    size: {
      type: String,
      default: '18',
    },
  },
}
</script>
